import { VehicleType } from "@/types/used-cars/used-cars.types";

export const getCarType = (type: string) => {
  if (type === 'used') {
    return VehicleType.Used;
  } else {
    return VehicleType.Demo;
  }
};

export const parsePresets = (presets: string[] | string) => {
  let brand, model, usedCarId;

  if (presets?.length) {
    brand = presets[0];
  }
  if (presets?.length > (1)) {
    model = presets[1];
  }
  if (presets?.length > (2)) {
    usedCarId = presets[2];
  }

  return {
    brand,
    model,
    usedCarId,
  }
};
